import React from 'react';
import { motion, AnimatePresence as AnimatePresenceComponent } from 'framer-motion';
import { sideMenuVariant, sMenuChildrenVariant } from './../../utils/anims/index';
import { useNavigate } from 'react-router-dom';
import { sideMenuData } from '../../data/sideMenu';
import { ISideMenu } from '../../models';
import CloseIconSvg from '../svgs/CloseIconSvg';
import { LogOut } from 'lucide-react';
import { logoutUser } from '../../utils/logoutUser';
import styles from './index.module.scss';

const AnimatePresence = AnimatePresenceComponent as React.FC<any>;

const SideMenu = ({ navState, setNavState }: ISideMenu) => {
	const navigate = useNavigate();
	return (
		<>
			<AnimatePresence>
				{navState && (
					<motion.section
						variants={sideMenuVariant}
						initial="hidden"
						animate="visible"
						exit="exit"
						className={`${styles.wrapper} position-fixed text-center`}
					>
						<section className="text-center d-flex justify-content-center w-100" style={{ justifyContent: 'center' }}>
							<div
								className={`${styles.close} my-5 py-2`}
								onClick={() => setNavState(false)}
								style={{ justifyContent: 'center', display: 'flex', justifySelf: 'center' }}
							>
								<CloseIconSvg width="20" height="25" viewBox="0 0 25 25" />
							</div>
						</section>

						<motion.section className="text-center d-flex flex-column flex-grow-1">
							{sideMenuData.map(({ id, name, component: Component, path }) => {
								return (
									<motion.div
										variants={sMenuChildrenVariant}
										key={id}
										className={`p-4 ${id === 1 && styles.bgHighlight} ${styles.cursor}`}
										onClick={() => navigate(path)}
									>
										<Component />
										<aside className={`${styles.text} text-center mt-2 -ml-4`}>{name}</aside>
									</motion.div>
								);
							})}

							<div className="border-t border-gray-300 my-4" />

							<motion.div
								variants={sMenuChildrenVariant}
								className={`p-4 ${styles.cursor} mt-auto`}
								onClick={logoutUser}
								style={{ paddingBottom: 'calc(50px + env(safe-area-inset-bottom))' }}
							>
								<div className="flex justify-center">
									<LogOut size={28} className="text-red-500" />
								</div>
								<aside className={`${styles.text} text-center mt-2 text-red-500`}>Logout</aside>
							</motion.div>
						</motion.section>
					</motion.section>
				)}
			</AnimatePresence>
		</>
	);
};

export default React.memo(SideMenu);
